module.exports = __webpack_public_path__ + "static/media/handbook.1e4891c1.svg";